var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { useMemo } from 'react';
import { CarouselIndicatorContainer, Indicator } from './elements';
export var CarouselIndicator = forwardRef(function (_a, fRef) {
    var currentIndex = _a.currentIndex, totalItems = _a.totalItems, _b = _a.contained, contained = _b === void 0 ? false : _b, _c = _a.indicatorType, indicatorType = _c === void 0 ? 'dots' : _c, rest = __rest(_a, ["currentIndex", "totalItems", "contained", "indicatorType"]);
    var indicators = useMemo(function () {
        return Array.from({ length: totalItems }, function (_, index) { return (React.createElement(Indicator, { indicatorType: indicatorType, key: index, "data-current": index === currentIndex })); });
    }, [currentIndex, totalItems, indicatorType]);
    return (React.createElement(CarouselIndicatorContainer, __assign({ contained: contained }, rest, { ref: fRef }), indicators));
});
